import { Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { Type } from 'src/app/analyses/interfaces/analyses.types';
import { AnalysesService } from 'src/app/analyses/services/analyses.service';

@Pipe({
  name: 'toTypeId',
})
export class ToTypeIdPipe implements PipeTransform {
  constructor(private readonly service: AnalysesService) {}

  transform(type: Observable<string> | string): Observable<string> {
    const type$ = typeof type === 'string' ? of(type) : type;
    return type$.pipe(
      switchMap((t) => {
        return this.service.getTypes().pipe(
          map((data: Type[]) => {
            const find = data.find((types) => types.type === t);
            return find ? find.id : undefined;
          })
        );
      })
    );
  }
}
